export const ERRORS = {
	PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
};
